import type { ReactNode } from 'react';
import { memo } from 'react';
import { AppScrollArea } from '@/components/ui/AppScrollArea';
import styles from './MobilePageLayout.module.css';

interface MobilePageLayoutProps {
  logo: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  /**
   * Vertically + horizontally center the content in the space below the top bar
   * (for short single-column screens: password gate, status, bootstrap error).
   * Default false keeps the top-aligned, scrollable flow used by onboarding /
   * invitation, whose forms fill the height themselves.
   */
  centerContent?: boolean;
}

export const MobilePageLayout = memo(function MobilePageLayout({
  logo,
  actions,
  children,
  centerContent = false,
}: MobilePageLayoutProps) {
  return (
    <div className={styles.wrapper}>
      <header className={styles.topBar}>
        {logo}
        {actions && <div className={styles.actions}>{actions}</div>}
      </header>
      <main className={styles.contentScroll}>
        {centerContent ? (
          <div className={styles.centeredContent}>{children}</div>
        ) : (
          <AppScrollArea fill>
            <div className={styles.content}>{children}</div>
          </AppScrollArea>
        )}
      </main>
    </div>
  );
});
